import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { NotificationService, NotificationConfig } from '../notification/notification.service';
import { NotificationComponent } from '../notification/notification.component';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'app-notification-container',
  standalone: true,
  imports: [CommonModule, NotificationComponent],
  templateUrl: './notification-container.component.html',
  styleUrls: ['./notification-container.component.scss'],
  animations: [
    trigger('notificationAnimation', [
      transition(':enter', [
        style({ transform: 'translateY(-100%)', opacity: 0 }),
        animate('300ms ease-out', style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ transform: 'translateY(-100%)', opacity: 0 }))
      ])
    ])
  ]
})
export class NotificationContainerComponent implements OnInit, OnDestroy {
  activeNotifications: NotificationConfig[] = [];
  private subscription!: Subscription;
  position: 'top' | 'bottom' = 'top';
  private readonly NOTIFICATION_HEIGHT = 80; // Height of each notification including margin
  private readonly NOTIFICATION_GAP = 10; // Gap between notifications

  constructor(@Inject(NotificationService) private notificationService: NotificationService) {}

  ngOnInit() {
    this.subscription = this.notificationService.notifications$.subscribe(
      notification => {
        this.activeNotifications.unshift(notification); // Add new notifications to the beginning
        if (this.activeNotifications.length > 5) { // Limit to 5 notifications
          this.activeNotifications.pop();
        }
      }
    );
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  removeNotification(index: number) {
    this.activeNotifications.splice(index, 1);
  }

  getNotificationPosition(index: number): number {
    return (this.NOTIFICATION_HEIGHT + this.NOTIFICATION_GAP) * index;
  }
}